<template>
  <div class="news-content">
    <div class="news-title-wrap">
      <h2 class="news-title wow fadeInUp">{{ newsDetails.data.title }}</h2>
      <div class="news-source-date">
        <div class="date-wrap wow fadeInUp" data-wow-delay="0.3s">
          <div class="date-icon-wrap">
            <img
              class="date-icon"
              src="https://img.jozobio.com/img/news/news_details_time_icon.png"
              alt="发布日期"
            />
          </div>
          <div class="date">
            发布于：
            <time class="datetime">{{
              $utils.setTime(newsDetails.data.create_time, "Y-M-D")
            }}</time>
          </div>
        </div>
        <div class="split-line wow fadeInUp" data-wow-delay="0.4s"></div>
        <div class="source-wrap wow fadeInUp" data-wow-delay="0.5s">
          发布来源：
          <strong class="source">{{ newsDetails.data.source }}</strong>
        </div>
        <div class="view-wrap wow fadeInRight" data-wow-delay="0.6s">
          <div class="view-icon-wrap">
            <img
              class="view-icon"
              src="https://img.jozobio.com/img/news/news_details_view_icon.png"
              alt="浏览量"
            />
          </div>
          <div class="view">浏览量：{{ newsDetails.data.num }}</div>
        </div>
      </div>
    </div>
    <!-- <section
      class="content content-text wow fadeInUp"
      data-wow-delay="0.3s"
      v-html="cContent(newsDetails.data.content)"
    ></section> -->
    <section
      class="content content-text not-html-css wow fadeInUp"
      data-wow-delay="0.3s"
      v-html="newsDetails.data.content"
    ></section>
    <div class="paging">
      <div
        class="page-btn prev wow fadeInLeft"
        data-wow-delay="0.4s"
        @click="page('previous')"
      >
        <div class="page-icon-wrap">
          <img
            class="page-icon"
            src="https://img.jozobio.com/img/news/news_details_prev_icon.png"
            alt="上一条新闻"
          />
        </div>
        <div class="page-title">
          上一篇：{{
            newsDetails.previous ? newsDetails.previous.title : "已经到底啦~"
          }}
        </div>
      </div>
      <div
        class="page-btn next wow fadeInRight"
        data-wow-delay="0.4s"
        @click="page('next')"
      >
        <div class="page-icon-wrap">
          <img
            class="page-icon"
            src="https://img.jozobio.com/img/news/news_details_next_icon.png"
            alt="下一条新闻"
          />
        </div>
        <div class="page-title">
          下一篇：{{
            newsDetails.next ? newsDetails.next.title : "已经到底啦~"
          }}
        </div>
      </div>
    </div>
    <div class="back-btn-wrap">
      <div
        class="back-btn btn wow fadeInUp"
        data-wow-delay="0.5s"
        @click="backNews"
      >
        <div class="back-icon-wrap">
          <img
            class="back-icon"
            src="https://img.jozobio.com/img/news/news_details_back_icon.png"
            alt="返回列表"
          />
        </div>
        <div class="btn-text">返回列表页</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    newsDetails: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      id: 0,
    };
  },
  watch: {
    newsDetails: {
      handler() {
        this.$nextTick(() => {
          this.checkImgWidthAttributes();
        });
      },
      immediate: true,
    },
  },
  computed: {
    cContent() {
      return function (value) {
        let str = value;
        console.log(value);
        if (value && value.indexOf("width" === -1)) {
          str = value.replace(/<img/g, '<img style="width:100%"');
        }
        return str;
      };
    },
  },
  methods: {
    checkImgWidthAttributes() {
      // 获取样式名为content的div元素
      const contentDiv = document.querySelector(".not-html-css");
      if (contentDiv) {
        // 查找div下的所有img标签
        const imgElements = contentDiv.querySelectorAll("img");
        for (let i = 0; i < imgElements.length; i++) {
          if (
            (!imgElements[i].getAttribute("width") &&
              !imgElements[i].getAttribute("height")) ||
            document.documentElement.clientWidth <= 980
          ) {
            imgElements[i].style.width = "94%";
            // imgElements[i].parentNode.style.padding = "0 3%";
            imgElements[i].parentNode.style.display = "flex";
            imgElements[i].parentNode.style.justifyContent = "center";
            imgElements[i].removeAttribute("height");
          }
        }
      }
    },
    page(type) {
      if (!this.newsDetails[type]) return;
      this.$router.replace({
        path: `/news_details/${this.newsDetails[type].id}`,
      });
      this.$router.go(0);
    },
    backNews() {
      this.$router.push({
        path: "/news",
        query: {
          p_index: this.$route.query.p_index,
        },
      });
      window.scroll(0, 0);
      this.$nextTick(() => {
        this.$store.commit("initWoW");
      });
    },
  },
};
</script>

<style scoped lang="less">
.news-content {
  padding: 0 1.8rem;
  .content-text {
    padding: 0 0.5rem 0.5rem;
  }
}
.news-title-wrap {
  margin-top: 0.7rem;
  border-bottom: 0.01rem solid #e6e6e6;
}
.news-title {
  text-align: center;
  font-size: 0.28rem;
  font-weight: 500;
  color: #090909;
}
.news-source-date {
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0.25rem 0 0.15rem;
  color: #838282;
}
.date-wrap {
  display: flex;
  align-items: center;
}
.date-icon-wrap {
  margin-right: 0.05rem;
}
.date-icon {
  width: 0.17rem;
  margin-bottom: 0.03rem;
}
.date,
.datetime,
.source-wrap,
.source,
.view {
  font-size: 0.14rem;
  font-weight: 400;
}
.split-line {
  width: 0.02rem;
  height: 0.14rem;
  margin: 0 0.07rem;
  background-color: #cccccc;
}
.view-wrap {
  display: flex;
  align-items: center;
  margin-left: 0.4rem;
}
.view-icon-wrap {
  margin-right: 0.08rem;
}
.view-icon {
  width: 0.2rem;
  margin-bottom: 0.03rem;
}

.content {
  padding: 0.3rem 0 0.7rem;
  border-bottom: 0.01rem solid #e6e6e6;
}
.paging {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-top: 0.15rem;
}
.page-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
}
.page-icon-wrap {
  margin-right: 0.07rem;
}
.page-icon {
  width: 0.22rem;
}
.page-title {
  font-size: 0.14rem;
  color: #333333;
}
.back-btn-wrap {
  display: flex;
  justify-content: center;
  margin-top: 0.2rem;
}
.back-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1.5rem;
  height: 0.45rem;
  background: linear-gradient(90deg, #0078ec 40%, #00c4ba 80%);
  border-radius: 0.25rem;
}
.back-icon-wrap {
  margin-right: 0.1rem;
}
.back-icon {
  width: 0.18rem;
  margin-bottom: 0.05rem;
}
.btn-text {
  font-size: 0.15rem;
  color: #fff;
}
</style>
